import { Controller } from "stimulus";
import { Turbo } from "@hotwired/turbo-rails";
import consumer from "../../entrypoints/src/admin/channels/consumer";

// Subscribes to a Turbo::StreamsChannel stream (the inbox of the company, an open conversation) through
// the ActionCable consumer the admin already keeps, and renders the turbo-stream messages it receives.
// It stands in for turbo_stream_from: that element lazy-loads its own @rails/actioncable chunk, which
// resolves relative to the page under the empty webpack publicPath (404), and would open a second
// websocket. Rendered by CommunicationHelper#communication_stream_tag.
export default class extends Controller {
  static values = { signedName: String };

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: "Turbo::StreamsChannel", signed_stream_name: this.signedNameValue },
      { received: (message) => Turbo.renderStreamMessage(message) }
    );
  }

  disconnect() {
    this.subscription?.unsubscribe();
    this.subscription = null;
  }
}
